/**
 * Created by rickborst on 13/02/2017.
 */

const Config = {
    dataSources: {
        kaltura: {

            // baseUrl: 'http://rest-eus1.ott.kaltura.com/restful/api_v3/service/',
            baseUrl: 'https://436-api.frs1.ott.kaltura.com/api_v3/service/',

            // baseUrl: 'http://rest-eus1.ott.kaltura.com/restful_v4_2/api_v3/service/',
            endPoints: {
                authenticateWithCredentials: 'ottUser/action/login',
                authenticateWithRefreshToken: 'ottUser/action/refreshSession',
                logout: 'ottUser/action/logout',
                resetPassword: 'ottUser/action/resetPassword',
                setPasswordWithToken: 'ottuser/action/setInitialPassword',
                getActiveUser: 'ottUser/action/get',
                updateUser: 'ottUser/action/update',
                registerUser: 'ottUser/action/register',
                entitlements: 'entitlement/action/list',
                subscriptions: 'subscription/action/list',
                paymentMethods: 'householdPaymentMethod/action/list',
                deviceList: 'householddevice/action/list',
                deviceAdd: 'householddevice/action/add',
                deviceDelete: 'householddevice/action/delete',
                deviceConnect: 'householddevice/action/addByPin',
                assetList: 'asset/action/list',
                asset: 'asset/action/get',
                bookmark: 'bookmark/action/list',
                category: 'ottCategory/action/get',
                multirequest: 'multirequest',
                changePassword: 'ottUser/action/updateLoginData',
                anonymousLogin: 'ottUser/action/anonymousLogin',
                listPaymentGateways: 'householdpaymentgateway/action/list',
                invokePaymentGateways: 'householdpaymentgateway/action/invoke',
                transactionPurchase: 'transaction/action/purchase',
                productPrice: 'productprice/action/list',
                addHousehold: 'household/action/add',
                setReminder: 'reminder/action/add',
                removeReminder: 'reminder/action/delete',
                getReminder: 'reminder/action/list',
                getServerTime: 'system/action/getTime'
            },
            defaults: {
                contentType: 'application/json',
                persistentPayload: {
                    apiVersion: '3.6.1532.14630'
                },
                methods: {
                    create: 'POST',
                    read: 'POST',
                    update: 'POST',
                    destroy: 'POST'
                }
            },
            presets: {
                partnerId: 442, // TODO: Retrieve partnerId from api?
                udid: localStorage.getItem('uniqueDeviceID') || 123456, // TODO: Generate device id?,
                mainViewsId: 2742,
                pageSize: 8
            },
            APIVersion: '3.6.1532.14630'
        }
    },
	POEditor: {
		awsLocalizationUrl: 'https://rkw5i2otx5.execute-api.eu-west-1.amazonaws.com/poeditor-localization',
		projectName: 'Kids-WEB',
		defaultLocale: 'he',
	},
    localisation: {
        default: 'iw'
    },
    firebase: {
        database:{
            seachange_redirection_addresses: 'https://kids-world-landing.firebaseio.com/seachange_redirection_addresses.json',
        },
    },
    seachange: {
        autoRedirect :"https://app.bigizone.co.il/",
        login:'https://app.bigizone.co.il/',
        registration:'https://app.bigizone.co.il/',
    }
};

export default Config;



// WEBPACK FOOTER //
// ./src/js/config.js